export default __webpack_public_path__ + "static/media/petgramImg_5.bb1d1bef.webp";